import React from "react"
import { Helmet } from "react-helmet"
import * as constants from "../constants"

export default () => (
  <Helmet>
    <title>{constants.FULLNAME}</title>
  </Helmet>
)
